import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  changespassword,
  profileData,
  notifications,
  profileupdateData,
  completedgames,
  playerRating,
  profileUpload,
  boardpiece,
  getboardpiece,
  allPlayerID,
} from '../const';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private navbarClasslist = new BehaviorSubject<boolean>(false);
  public usernameData = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient) {}

  profileData(username: any) {
    let profiledetails = { username };
    return this.http.post<any>(`${profileData}`, profiledetails);
  }

  profileGameData(
    username: any,
    page: number,
    result: string,
    asedecDate: string
  ) {
    let profiledetails = { username };
    return this.http.post<any>(
      `${completedgames}?page=${page}&result=${result}&date=${asedecDate}`,
      profiledetails
    );
  }

  settingprofileData(username: any) {
    let profiledetails = { username };
    return this.http.post<any>(`${profileData}`, profiledetails);
  }

  profileupdateData(data: any) {
    return this.http.patch<any>(`${profileupdateData}`, data);
  }

  changespassword(data: any) {
    return this.http.post<any>(`${changespassword}`, data);
  }

  notificationData() {
    return this.http.get<any>(`${notifications}`);
  }

  playerRating() {
    return this.http.get<any>(`${playerRating}`);
  }

  profileUploadData(data: any) {
    return this.http.post<any>(`${profileUpload}`, data);
  }

  boardPiecedata(data: any) {
    return this.http.post<any>(`${boardpiece}`, data);
  }

  boardgetdata() {
    return this.http.get<any>(getboardpiece);
  }

  homePageRoute(data: any) {
    this.navbarClasslist.next(data);
  }

  navbarRouter() {
    return this.navbarClasslist;
  }

  // allplayerData(page: number, data: string) {
  //   return this.http.get<any>(`${allPlayerID}?page=${page}&query=${data}`);
  // }

  allplayerData(query: string, page: number): Observable<any> {
    return this.http.get(`${allPlayerID}?page=${page}&query=${query}`);
  }

  searchuserData(data:any) {
      this.usernameData.next(data);
  }
}
